"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SprayAppFieldsToJSON = exports.SprayAppFieldsFromJSONTyped = exports.SprayAppFieldsFromJSON = void 0;
const runtime_1 = require("../runtime");
function SprayAppFieldsFromJSON(json) {
    return SprayAppFieldsFromJSONTyped(json, false);
}
exports.SprayAppFieldsFromJSON = SprayAppFieldsFromJSON;
function SprayAppFieldsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'field': !runtime_1.exists(json, 'field') ? undefined : json['field'],
        'acres': !runtime_1.exists(json, 'acres') ? undefined : json['acres'],
    };
}
exports.SprayAppFieldsFromJSONTyped = SprayAppFieldsFromJSONTyped;
function SprayAppFieldsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field': value.field,
        'acres': value.acres,
    };
}
exports.SprayAppFieldsToJSON = SprayAppFieldsToJSON;
